import useStore from "../../../store"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { DateTime } from "luxon"
import DashboardContainer from "../../common/DashboardContainer"
import { Widget, WidgetBody, WidgetHeader } from "../../ui/Widget"
import InfoItem from "../../common/InfoItem"
import FieldAuditUnits from "./FieldAuditUnits/FieldAuditUnits"
import LotDetails from "./LotDetails/LotDetails"

export default function FieldAudit() {
  const { fieldAuditId } = useParams()
  const fieldAudit = useStore((state) => state.fieldAudit)
  const fetchFieldAudit = useStore((state) => state.fetchFieldAudit)

  const [fetchingFieldAudit, setFetchingFieldAudit] = useState(true)

  const isVisible = !fetchingFieldAudit || fieldAudit?.id === fieldAuditId

  useEffect(() => {
    fetchFieldAudit(fieldAuditId,
      () => setFetchingFieldAudit(false)
    )
  }, [fieldAuditId])

  return(
    <DashboardContainer>
      <Widget>
        <WidgetHeader
          title={`${!fetchingFieldAudit || fieldAudit?.id === fieldAuditId ? fieldAudit.attributes.dealer.lotname : ''} Audit`}
          showSpinner={fetchingFieldAudit}
        />
        <WidgetBody
          styles="w-full grid grid-cols-2 lg:grid-cols-3"
          isVisible={isVisible}
        >
          <InfoItem title='Status'>
            {fieldAudit?.attributes['status-name']}
          </InfoItem>
          <InfoItem title='Time Started'>
            {DateTime.fromISO(fieldAudit?.attributes['time-started']).toLocaleString()}
          </InfoItem>
          <InfoItem title='Status by'>
            {fieldAudit?.attributes['status-by'].name}
          </InfoItem>
        </WidgetBody>
      </Widget>

      <Widget>
        <WidgetHeader
          title="Dealer Information"
        />
        <WidgetBody
          styles="w-full grid grid-cols-2 lg:grid-cols-3"
          isVisible={isVisible}
        >
          <InfoItem title='Activated on'>
            {DateTime.fromISO(fieldAudit?.attributes.dealer['active_at']).toLocaleString()}
          </InfoItem>
          <InfoItem title='Last Stock #'>
            {fieldAudit?.attributes.dealer['most_recent_stock_number']}
          </InfoItem>
        </WidgetBody>
      </Widget>

      <LotDetails
        fieldAudit={fieldAudit}
      />

      <FieldAuditUnits fieldAuditId={fieldAuditId} />
    </DashboardContainer>
  )
}